import { IDeclaracaoPrimeiroAdquirente } from '../interfaces/IDeclaracoes';

export const mesesSemDeclaracoes = (declaracoes: IDeclaracaoPrimeiroAdquirente[], meses: number[]) => {
  // Gera um array com os meses de 1 a 12

  // Extrai os meses das declarações (já considerando que estão no formato 1 a 12)
  const mesesComDeclaracoes = declaracoes.map((declaracao) => declaracao.exercicioMes);

  // Filtra os meses que não têm declarações
  const mesesSemDeclaracoes = meses.filter((mes) => !mesesComDeclaracoes.includes(mes));

  return mesesSemDeclaracoes;
};
